/**
 * Admin — Evaluations sub-feature manifest.
 *
 * 2 contextes : `admin-evaluations` (liste + CRUD) et `admin-evaluation-form`
 * (édition d'une évaluation). Lien sidebar "Admin" filtré par rôle 'admin'.
 */

import { Layers, LayoutList, ShieldAlert, SlidersHorizontal, Sparkles } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { ADMIN_PATHS } from '../router/paths';
import { adminEvaluationsRoutes } from './routes';

export const adminEvaluationsManifest: FeatureManifest = {
  id: 'admin-evaluations',
  contexts: [CONTEXTS.ADMIN_EVALUATIONS, CONTEXTS.ADMIN_EVALUATION_FORM],

  routes: [
    { routes: adminEvaluationsRoutes, errorFallbackLabel: 'Évaluations', guard: ADMIN_GUARD },
  ],

  centerView: {
    [CONTEXTS.ADMIN_EVALUATIONS]: lazyView(
      () => import('../views/AdminEvaluationsListView'),
      'AdminEvaluationsListView',
    ),
    [CONTEXTS.ADMIN_EVALUATION_FORM]: lazyView(
      () => import('../views/AdminEvaluationFormView'),
      'AdminEvaluationFormView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_EVALUATIONS]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
          {
            id: 'admin-eval-filters',
            label: 'Filtres',
            icon: SlidersHorizontal,
            view: lazyView(() => import('../views/AdminEvalFiltersView'), 'AdminEvalFiltersView'),
          },
        ],
        [CONTEXTS.ADMIN_EVALUATION_FORM]: [
          {
            id: 'admin-nav',
            label: 'Navigation',
            icon: LayoutList,
            view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
          },
        ],
      },
    },
    right: {
      tabs: {
        [CONTEXTS.ADMIN_EVALUATION_FORM]: [
          {
            id: 'eval-variants',
            label: 'Variantes',
            icon: Layers,
            view: lazyView(() => import('../views/AdminEvalVariantsView'), 'AdminEvalVariantsView'),
          },
          {
            id: 'eval-prompt',
            label: 'Prompt',
            icon: Sparkles,
            view: lazyView(() => import('../views/AdminEvalPromptView'), 'AdminEvalPromptView'),
          },
        ],
      },
    },
  },

  navigation: [
    {
      id: 'admin',
      label: 'Admin',
      icon: ShieldAlert,
      to: ADMIN_PATHS.evaluations.list,
      position: 'bottom',
      order: 50,
    },
  ],

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_EVALUATIONS]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_EVALUATION_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: true, defaultActiveTab: 'eval-variants' },
    },
  },
};
